import { atom } from 'recoil';

export const recommenderRecipesRequestIdAtom = atom({
  key: 'apiData/requestIdAtoms/recommenderRecipesRequestId',
  default: 0,
});

export const recommenderMealplanRequestIdAtom = atom({
  key: 'apiData/requestIdAtoms/recommenderMealplanRequestId',
  default: 0,
});

export const recommenderExercisesRequestIdAtom = atom({
  key: 'apiData/requestIdAtoms/recommenderExercisesRequestId',
  default: 0,
});
